<mat-toolbar class="confirm-header">
    <h5>
      {{ title || 'CONFIRM'}}   
      </h5>
</mat-toolbar>
<div class="confirm-body">
<div class="row confirm-content">
  <span class="msg">
    {{msg}}
  </span>
</div>
<br>


<div class="row text-center" *ngIf="caseCheck">
  <mat-form-field  class="text-center" *ngIf="userRole == 'CLERK' || userRole == 'JUDGE'">
    <input matInput type="text" placeholder="Case Number" 
      name="caseNumber" [(ngModel)]="caseNumber">
  </mat-form-field>
</div>


<div class="row text-center">
  <button mat-raised-button color="warn" *ngIf="!achCheck" (click)="dialogRef.close(false)">
      <span>  {{ errorButtonText || 'CANCEL'}} </span>
    </button>

    <button mat-raised-button color="warn" *ngIf="achCheck" (click)="dialogRef.close('DONT_REMIND')">
      <span>  {{ errorButtonText || 'CANCEL'}} </span>
    </button>

  <button mat-raised-button color="accent" *ngIf="achCheck" (click)="dialogRef.close(false)">
      <span>  REMIND ME LATER </span>
  </button>

  <button mat-raised-button color="accent" *ngIf="!caseCheck" (click)="dialogRef.close(true)">
    <span>  {{ successButtonText || 'CONFIRM'}}   </span>
  </button>


  <button mat-raised-button color="accent" [disabled]="!caseNumber" *ngIf="caseCheck" (click)="dialogRef.close(caseNumber)">
    <span>{{ successButtonText || 'CONFIRM'}} </span>
  </button>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/confirmation-dialog/confirmation-dialog.component.html